import {IComponentOptions} from 'angular';
import IScope = angular.IScope;
declare let require: any;
let template = require('./dv-accordion.html');

export class DvAccordionComponentConfig implements IComponentOptions {
    transclude = true;
    template = template;
    controller = DvAccordionController;
    controllerAs = 'vma';
    bindings: any = {
        allowMultipleSections: '<',
        selectedTabIds: '<'
    };
}

export class DvAccordionController {
    accordion: string[] = [];
    allowMultipleSections: boolean;
    selectedTabIds: string[] = [];

    static $inject: any[] = ['$scope'];
    /* @ngInject */
    constructor(private $scope: IScope) {

    }

    $onInit() {
        // erlaubt dass man von Anfang an, mehrere Tabs oeffnet, wenn man eine bestimmte Mitteilung oeffnen will
        this.initView();

        this.$scope.$watchCollection(() => {
            return this.selectedTabIds;
        }, (newValue, oldValue) => {
            this.initView();
        });
    }

    private initView() {
        if (this.selectedTabIds) {
            for (let selectedTabId of this.selectedTabIds) {
                this.openTag(selectedTabId);
            }
        }
    }

    public toggleTab(i: string): void {
        if (this.isTagOpen(i)) {
            this.closeTag(i);
        } else {
            this.openTag(i);
        }
    }

    private openTag(i: string) {
        if (!this.allowMultipleSections) {
            this.accordion = [];
        }
        this.accordion.push(i);
    }

    private closeTag(i: string) {
        this.accordion.splice(this.accordion.indexOf(i), 1);
    }

    public isTagOpen(i: string): boolean {
        return this.accordion.indexOf(i) > -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-accordion/dv-accordion.ts